// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contBox[data-v-08d62650] {\n  align-items: flex-start !important;\n}\n.contBox[data-v-08d62650] .ant-form-item-children {\n  display: flex;\n}\n.btnBox[data-v-08d62650] {\n  width: 100%;\n  display: flex;\n  margin-top: 20px;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
